import script from "./BsCustomModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BsCustomModal.vue?vue&type=script&setup=true&lang=js"

import "./BsCustomModal.vue?vue&type=style&index=0&id=8e2ef2d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e2ef2d8"]])

export default __exports__